import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './Rightbar.less';
import { ColorPicker, Popover, Slider, Switch, Tooltip } from 'antd';
import caIcon from '@/assets/texture/ca.png';
import caResetIcon from '@/assets/texture/ca-reset.png';
import caCombineIcon from '@/assets/texture/ca-combine.png';

import closeIcon from '@/assets/texture/close.png';
import closeSelectedIcon from '@/assets/texture/closeSelected.png';

import caDeleteIcon from '@/assets/texture/delete.png';
import brushIcon from '@/assets/texture/brush.png';
import quanIcon from '@/assets/texture/quan.png';

import caSelectedIcon from '@/assets/texture/caSelected.png';
import caResetSelectedIcon from '@/assets/texture/ca-resetSelected.png';
// import caSelectedCombineIcon from '@/assets/texture/ca-combineSelected.png';

// import caSelectedDeleteIcon from '@/assets/texture/deleteSelected.png';
import brushSelectedIcon from '@/assets/texture/quanSelected.png';
import quanSelectedIcon from '@/assets/texture/brushSelected.png';

import ColorAndPenPicker from '@/components/ColorAndPenPicker/ColorAndPenPicker';
import {
  clearInpainting,
  deleteInpainting,
  inpaintDraw,
  inpaintErase,
  inpaintOriginal,
} from '@/utils/unityTool';

export default forwardRef(function Rightbar({ sendMessage, onBrushIsPaint, images }, ref) {
  const [layer, setLayer] = useState(0);
  const [brush, setBrush] = useState(false);

  const [switchLayerErase, setSwitchLayerErase] = useState(false);
  const [switchLayerRecorver, setSwitchLayerRecorver] = useState(false);
  const [layerCombine, setLayerCombine] = useState(false);
  const [discardLayersEnable, setDiscardLayersEnable] = useState(true);

  const [isInpaint, setIsInpaint] = useState(false);

  const [onInpaint, setOnInpaint] = useState(false);
  const [onInpaintErase, setOnInpaintErase] = useState(false);
  const [reset, setReset] = useState(false);
  const [matIndex, setMatIndex] = useState(0);

  const [setPenColor, setSetPenColor] = useState(false);
  const [models, setModels] = useState([]);

  const [colorAndPenPickerOpen, setColorAndPenPickerOpen] = useState(false);
  const timeoutRef = useRef(null);

  const [uvChanged, setUvChanged] = useState(0);
  const [fade, setFade] = useState(10);
  const [colorAndPenPickerKey, setColorAndPenPickerKey] = useState(1);

  const [isInpaintGenerate, setIsInpaintGenerate] = useState(false);

  // 3秒自动关闭逻辑
  const openPopover = () => {
    if (onInpaint) {
      clearTimeout(timeoutRef.current);
      setColorAndPenPickerOpen(true);
    }
  };

  const closePopoverDelayed = () => {
    console.log('leave');
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setColorAndPenPickerOpen(false);
    }, 2000);
  };

  const cancelClose = () => {
    clearTimeout(timeoutRef.current);
  };

  useImperativeHandle(ref, () => ({
    resetValues() {
      // setUvChanged(0);
      // setFade(10);
      // sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged 0');
      // sendMessage('ContextManager', 'OnCmdExec', 'OnFadeSliderChanged 10');

      setBrush(false);
      setSwitchLayerErase(false);
      setSwitchLayerRecorver(false);
      setOnInpaintErase(false);
      setOnInpaint(false);
      setColorAndPenPickerOpen(false);
      // setColorAndPenPickerKey(colorAndPenPickerKey + 1);
      sendMessage('ContextManager', 'OnCmdExec', 'OnMatChanged 0');
    },
    //生成完成
    onGenerateFinish(isInpaintGenerate) {
      setIsInpaintGenerate(isInpaintGenerate);
      setFade(10);
      sendMessage('ContextManager', 'OnCmdExec', 'OnFadeSliderChanged ' + 10);
    },
  }));

  const downloadTexture = () => {
    sendMessage('ContextManager', 'OnCmdExec', 'OnTextureSave');
  };

  useEffect(() => {
    window.onUnityMatChanged = (index) => {
      console.log('onUnityMatChanged=', index);
      setMatIndex(index * 1);
    };
  }, []);
  return (
    <div
      className="right-bar"
      onClick={() => {
        setColorAndPenPickerOpen(false);
      }}>
      <div className="right-bar-content">
        <div className="right-bar-content-wrapper">
          <div className="title">Layer Tools</div>
          <div className="layer-tools">
            <Tooltip title="Layer Eraser">
              <div
                onClick={() => {
                  if (!switchLayerErase) {
                    onBrushIsPaint(true);
                    setIsInpaint(true);
                    setSwitchLayerErase(true);
                    setSwitchLayerRecorver(false);
                    setBrush(false);
                    setOnInpaintErase(false);
                  } else {
                    setSwitchLayerErase(false);
                  }

                  setBrush(false);
                  setOnInpaint(false);
                  onBrushIsPaint(false);
                  setIsInpaint(false);

                  sendMessage(
                    'ContextManager',
                    'OnCmdExec',
                    'OnLayerErase ' + (switchLayerErase ? 0 : 1),
                  );
                }}
                className={'layer-item ' + (switchLayerErase ? 'selected' : '')}>
                <img src={switchLayerErase ? caSelectedIcon : caIcon}></img>
              </div>
            </Tooltip>
            <Tooltip title="Layer Recorver">
              <div
                onClick={() => {
                  if (!switchLayerRecorver) {
                    onBrushIsPaint(true);
                    setIsInpaint(true);
                    setSwitchLayerRecorver(true);
                    setSwitchLayerErase(false);
                    setBrush(false);
                    setOnInpaintErase(false);
                  } else {
                    setSwitchLayerRecorver(false);
                  }
                  setBrush(false);
                  setOnInpaint(false);
                  onBrushIsPaint(false);
                  setIsInpaint(false);
                  sendMessage(
                    'ContextManager',
                    'OnCmdExec',
                    'OnLayerRecover ' + (switchLayerRecorver ? 0 : 1),
                  );
                }}
                className={'layer-item ' + (switchLayerRecorver ? 'selected' : '')}>
                <img src={switchLayerRecorver ? caResetSelectedIcon : caResetIcon}></img>
              </div>
            </Tooltip>
            <Tooltip title="Combine Layer">
              <div
                onClick={() => {
                  // if (!layerCombine) {
                  //   setLayerCombine(true);
                  //   setSwitchLayerRecorver(false);
                  //   setSwitchLayerErase(false);
                  //   setBrush(false);
                  //   setOnInpaint(false);
                  // } else {
                  //   setLayerCombine(false);
                  // }
                  sendMessage('ContextManager', 'OnCmdExec', 'OnLayerCombine 1');
                }}
                className={'layer-item '}>
                <img src={caCombineIcon}></img>
              </div>
            </Tooltip>
            <Tooltip title="Clear Layers">
              <div
                onClick={() => {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnDiscardLayers 1');
                }}
                className={'layer-item '}>
                <img src={closeIcon}></img>
              </div>
            </Tooltip>
          </div>

          <div className="title">Brush Tools</div>
          <div className="brush-wrapper">
            <div className="brush-tools">
              <Tooltip title="Inpaint Original [Q]">
                <div
                  onClick={() => {
                    if (!brush) {
                      onBrushIsPaint(true);
                      setIsInpaint(true);
                      setBrush(true);
                      setOnInpaint(false);
                      setSwitchLayerRecorver(false);
                      setSwitchLayerErase(false);
                      setOnInpaintErase(false);
                    } else {
                      setBrush(false);
                      onBrushIsPaint(false);
                      setIsInpaint(false);
                    }
                    inpaintOriginal(sendMessage, brush);
                  }}
                  className={'brush-item ' + (brush ? 'selected' : '')}>
                  <img src={brush ? brushSelectedIcon : brushIcon}></img>
                </div>
              </Tooltip>
              <Popover
                color="#222"
                style={{ padding: 0 }}
                open={colorAndPenPickerOpen}
                content={
                  <div onMouseEnter={cancelClose} onMouseLeave={closePopoverDelayed}>
                    <ColorAndPenPicker
                      key={'color_' + colorAndPenPickerKey}
                      onColorChange={(v) => {
                        sendMessage(
                          'ContextManager',
                          'OnCmdExec',
                          'SetPenColor ' + (typeof v === 'string' ? v : v.toHexString()),
                        );
                      }}
                      onSizeChange={(v) => {
                        sendMessage('ContextManager', 'OnCmdExec', 'AdjustBrushSize ' + v);
                      }}></ColorAndPenPicker>
                  </div>
                }
                title="">
                <Tooltip title="Inpaint Draw [W]">
                  <div
                    onMouseEnter={openPopover}
                    onMouseLeave={closePopoverDelayed}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (!onInpaint) {
                        setBrush(false);
                        setOnInpaint(true);
                        onBrushIsPaint(true);
                        setColorAndPenPickerOpen(true);
                        setSwitchLayerRecorver(false);
                        setSwitchLayerErase(false);
                        setOnInpaintErase(false);
                      } else {
                        setOnInpaint(false);
                        onBrushIsPaint(false);
                        setColorAndPenPickerOpen(false);
                      }
                      inpaintDraw(sendMessage, onInpaint);
                    }}
                    className={'brush-item ' + (onInpaint ? 'selected' : '')}>
                    <img src={onInpaint ? quanSelectedIcon : quanIcon}></img>
                  </div>
                </Tooltip>
              </Popover>
              <Tooltip title="Inpaint Erase [E]">
                <div
                  onClick={() => {
                    setOnInpaintErase(!onInpaintErase);
                    onBrushIsPaint(false);
                    if (onInpaintErase == 0) {
                      setBrush(false);
                      setOnInpaint(false);
                      onBrushIsPaint(true);
                      setSwitchLayerRecorver(false);
                      setSwitchLayerErase(false);
                    }
                    inpaintErase(sendMessage, onInpaintErase == 0 ? 1 : 0);
                  }}
                  className={'brush-item ' + (onInpaintErase ? 'selected' : '')}>
                  <img src={onInpaintErase ? caSelectedIcon : caIcon}></img>
                </div>
              </Tooltip>
              <Tooltip title="Clear Inpainting">
                <div
                  onClick={() => {
                    onBrushIsPaint(false);
                    setBrush(false);
                    setOnInpaint(false);
                    setOnInpaintErase(false);
                    setSwitchLayerErase(false);
                    setSwitchLayerRecorver(false);
                    clearInpainting(sendMessage);
                  }}
                  className={'brush-item'}>
                  <img src={caDeleteIcon}></img>
                </div>
              </Tooltip>
            </div>
            <div
              className={'delete-inpainting-button ' + (isInpaintGenerate ? '' : 'disabled')}
              onClick={() => {
                if (isInpaintGenerate) {
                  setIsInpaintGenerate(false);
                  deleteInpainting(sendMessage);
                }
              }}>
              Delete Inpainting
            </div>
          </div>

          {/* <div
            className="reset-inpainting-button"
            onClick={() => {
              sendMessage('ContextManager', 'OnCmdExec', 'reset');
            }}>
            Reset
          </div> */}

          <div className="preview">
            <div className="title">Texture Preview</div>
            <div style={{ flex: 1 }}></div>
            <Switch
              disabled={matIndex !== 0}
              checkedChildren="2D"
              unCheckedChildren="3D"
              onChange={(val) => {
                if (val) {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged ' + 1);
                } else {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged ' + 0);
                }
              }}></Switch>
          </div>
          <div className={'preview-images ' + (images && images.length > 1 ? '' : 'single')}>
            {images &&
              images.map((item, i) => {
                return (
                  <div key={i} className={'image '}>
                    <img src={'data:image/png;base64, ' + item.data}></img>
                  </div>
                );
              })}
          </div>

          <div className="slider-row">
            <div className="title">{matIndex === 1 ? 'Contrast' : 'No Content'}</div>
            <Slider
              min={0}
              max={1}
              style={{ flex: 1 }}
              step={0.05}
              value={uvChanged}
              disabled={matIndex !== 1}
              onChange={(value) => {
                setUvChanged(value);
                sendMessage('ContextManager', 'OnCmdExec', 'OnUVChanged ' + (1 - value));
              }}></Slider>
          </div>
          <div className="slider-row">
            <div className="title">Feathering</div>
            <Slider
              min={0}
              max={10}
              value={fade}
              disabled={!isInpaintGenerate}
              style={{ flex: 1 }}
              step={1}
              onChange={(value) => {
                setFade(value);
                setTimeout(() => {
                  sendMessage('ContextManager', 'OnCmdExec', 'OnFadeSliderChanged ' + value);
                });
              }}></Slider>
          </div>
        </div>
      </div>
      <div
        className="download-button"
        onClick={() => {
          downloadTexture();
        }}>
        Download Texture
      </div>
    </div>
  );
});
